import React from 'react';
const links = [{
  label: 'Estrategia',
  href: '#estrategia'
}, {
  label: 'Terminal',
  href: '#terminal'
}];
export function SiteHeader() {
  return <header className="sticky top-0 z-50 w-full border-b border-line bg-ink/90 backdrop-blur-md" data-id="element-79" data-mp="19tf5b20g76go">
      <div className="mx-auto flex h-14 w-full max-w-[1400px] items-center justify-between px-5 sm:h-16 sm:px-6 lg:px-10" data-id="element-80" data-mp="1np0qey3k963t">
        <a href="#top" className="flex items-baseline gap-2" data-id="element-81" data-mp="uy8w66622rj4">
          <span className="text-[14px] font-semibold tracking-tight text-white sm:text-[15px]" data-id="element-82" data-mp="uyisebhp1ux9">
            Indicadores
          </span>
          <span className="font-mono text-[12px] font-medium tracking-[0.18em] text-gold-vip sm:text-[13px]" data-id="element-83" data-mp="14w5993ijzwjv">
            VIP
          </span>
        </a>

        <nav aria-label="Principal" className="flex items-center gap-1" data-id="element-84" data-mp="zvr1lmkv6omd">
          {links.map(link => <a key={link.href} href={link.href} className="hidden rounded px-3 py-2 text-[13px] text-white/60 transition-colors duration-150 ease-out hover:text-white focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-cyan-vip sm:block" data-id="element-85" data-mp="2g9qyspsbs05x">
              {link.label}
            </a>)}
          <a href="#acceso" className="ml-1 whitespace-nowrap rounded-md border border-cyan-vip/40 px-3 py-1.5 text-[12px] font-medium text-cyan-vip transition-colors duration-150 ease-out hover:bg-cyan-vip/10 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-cyan-vip sm:text-[13px]" data-id="element-86" data-mp="2jj1azc3ned6w">
            Acceso VIP
          </a>
        </nav>
      </div>
    </header>;
}